/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles, useTheme } from '@material-ui/styles';
import { Grid, Link, Typography, Tooltip, useMediaQuery } from '@material-ui/core';

const PeriodList = ({ classes, items, period_hours }) => {
  const [list, setList] = useState(items);
  const mdSize = useMediaQuery(useTheme().breakpoints.only('md'));
  const xsSize = useMediaQuery(useTheme().breakpoints.down('xs'));

  let modDivisor = 5;
  if (mdSize) modDivisor = 8;

  const toolTipPeriods = {};
  Object.keys(items).forEach(item => {
    toolTipPeriods[item] = false;
  });

  const [toolTipsOpen, setToolTipsOpen] = useState(toolTipPeriods);
  const addFour = item => {
    const [hour] = item.split(':');
    const toInt = parseInt(hour, 10) + period_hours;
    const time = `${toInt}h`;
    const moreFour = toInt < 10 ? `0${time}` : `${time}`;
    return `${hour}h às ${moreFour}`;
  };

  const formatDayAndMonth = date => {
    const [, month, day] = date.split('-');
    return `${day}/${month}`;
  };

  useEffect(() => {
    setList(items);
  }, [items]);

  return (
    <Grid container spacing={0}>
        <Grid item xs={12} className={classes.content}>
          {Object.entries(list).map(([key, value], idx) => (
              <Tooltip
                key={key}
                arrow
                open={toolTipsOpen[key]}
                title={
                  <>
                    {value.map(item => (
                      <Typography key={item} variant="body2" className={classes.tooltip}>
                        {addFour(item)}
                      </Typography>
                    ))}
                  </>
                }
              >
                <Link
                  align="center"
                  color="textPrimary"
                  className={classes.link}
                  onClick={() => {
                    setToolTipsOpen({ ...toolTipPeriods, [key]: !toolTipsOpen[key] });
                  }}
                >
                  <div />
                  <Typography
                    variant={xsSize ? 'overline' : 'body2'}
                    color="textPrimary"
                    style={{ textTransform: 'initial' }}
                  >
                    {formatDayAndMonth(key)}
                  </Typography>
                  <Typography
                    variant={xsSize ? 'overline' : 'body2'}
                    color="textPrimary"
                    style={{ textTransform: 'initial' }}
                  >
                    {idx + 1 === 0 || (idx + 1) % modDivisor ? '|' : ''}
                  </Typography>
                </Link>
              </Tooltip>
            ))}
        </Grid>
      </Grid>
  );
};

PeriodList.propTypes = {
  classes: PropTypes.object.isRequired,
  items: PropTypes.object.isRequired,
  period_hours: PropTypes.number.isRequired,
};

const styles = theme => ({
  content: {
    display: 'grid',
    gridTemplateColumns: 'repeat(5, 1fr)',
    border: '1px solid #797979',
    borderRadius: '4px',
    // margin: '5px',
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: 'repeat(8,1fr)',
    },
  },
  tooltip: {
    color: '#fff',
  },
  link: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '18px',
    '&:hover': {
      color: '#000',
      fontWeight: '500',
    },
  },
});

export default withStyles(styles)(PeriodList);
